// drawer.js — respects default open on first paint and updates ARIA

const drawers = qsa('.drawer');

if (drawers.length) {
  drawers.forEach((drawer, idx) => {
    const title = qs('.drawer__title', drawer);
    const contents = qs('.drawer__contents', drawer);

    // Guard rails
    if (!title) return;

    // A11y wiring
    const contentId = contents ? (contents.id || `drawer-panel-${idx}`) : `drawer-panel-${idx}`;
    if (contents) contents.id = contentId;
    title.setAttribute('aria-controls', contentId);

    function open() {
      drawer.style.height = `${drawer.scrollHeight}px`;
      drawer.classList.add('drawer--open');
      title.setAttribute('aria-expanded', 'true');
    }

    function close() {
      drawer.style.height = `${title.offsetHeight}px`;
      drawer.classList.remove('drawer--open');
      title.setAttribute('aria-expanded', 'false');
    }

    // --- Initial state BEFORE first paint ---
    const wantsOpen =
      drawer.classList.contains('drawer--open') ||
      drawer.getAttribute('data-default-open') === 'true';

    drawer.style.height = wantsOpen ? `${drawer.scrollHeight}px` : `${title.offsetHeight}px`;
    title.setAttribute('aria-expanded', wantsOpen ? 'true' : 'false');

    // If you rely on it, keep forceLayout to lock initial style calc
    if (typeof forceLayout === 'function') forceLayout();

    // Mark ready next frame (so CSS transitions can key off .is-ready)
    requestAnimationFrame(() => {
      drawer.classList.add('is-ready');
    });

    // Recalc height if images load and content grows while default-open
    if (wantsOpen && contents) {
      requestAnimationFrame(() => open());
      contents.querySelectorAll('img').forEach(img => {
        if (!img.complete) img.addEventListener('load', () => open(), { once: true });
      });
    }

    // One-open-at-a-time behavior
    if (drawer.classList.contains('drawer--shy')) {
      window.addEventListener('drawer-toggle', evt => {
        if (evt.detail.el !== drawer) close();
      });
    }

    // Toggle on click (container click matches your original)
    drawer.addEventListener('click', () => {
      let status = 'open';
      if (drawer.classList.contains('drawer--open')) {
        if (drawer.classList.contains('drawer--shy')) return;
        close();
        status = 'closed';
      } else {
        open();
      }
      window.dispatchEvent(new CustomEvent('drawer-toggle', { detail: { el: drawer, status } }));
    });
  });

  // Keep heights correct on resize
  let windowWidth = window.innerWidth;

  function onResize() {
    if (typeof windowWidth === 'undefined' || window.innerWidth === windowWidth) return;
    windowWidth = window.innerWidth;

    drawers.forEach(drawer => {
      const title = qs('.drawer__title', drawer);
      if (!title) return;
      if (drawer.classList.contains('drawer--open')) {
        drawer.style.height = `${drawer.scrollHeight}px`;
      } else {
        drawer.style.height = `${title.offsetHeight}px`;
      }
    });
  }

  window.addEventListener('resize', debounce(onResize));
}
